import { render, staticRenderFns } from "./itemPressReleasesNew.vue?vue&type=template&id=030c480c&scoped=true&"
import script from "./itemPressReleasesNew.vue?vue&type=script&lang=js&"
export * from "./itemPressReleasesNew.vue?vue&type=script&lang=js&"
import style0 from "./itemPressReleasesNew.vue?vue&type=style&index=0&id=030c480c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030c480c",
  null
  
)

export default component.exports